<template>
  <div class="option-group-description" v-html="description"></div>
</template>

<script>
export default {
  name: 'OptionGroupDescription',
  props: {
    description: {
      type: String,
      default: ''
    }
  }
}
</script>

<style lang="scss" scoped>
.option-group-description {
  background: #f4f4f4;
  border-radius: 10px;
  margin: 0 20px 15px;
  padding: 12px 15px;
  font-weight: 500;
  color: #4f4f4f;
  line-height: 1.4;

  :deep(p) {
    margin: 0;

    & + p {
      margin-top: 8px;
    }
  }
}
</style>
